import script from "./MaximumWorkingHoursForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./MaximumWorkingHoursForm.vue?vue&type=script&setup=true&lang=ts"

import "./MaximumWorkingHoursForm.vue?vue&type=style&index=0&id=2f2a1e09&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f2a1e09"]])

export default __exports__